import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ru';

dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.locale('ru');

export const parseUtc = (value: any) => (value ? dayjs.utc(value) : null);

export const parseUtcString = (value: string | null, format: string) =>
  value ? dayjs.utc(value, format) : null;

export const formatUtc = (value: any, format: string = 'DD.MM.YYYY HH:mm') => {
  const parsed = parseUtc(value);
  return parsed ? parsed.format(format) : '';
};

export const toUtcISOString = (
  value: any,
  format: string = 'DD.MM.YYYY HH:mm'
): string | null => {
  if (!value) return null;
  const parsed = typeof value === 'string' ? parseUtcString(value, format) : value;
  return parsed && parsed.isValid() ? parsed.utc().toISOString() : null;
};

export const createMonthDate = (year: number, month: number) =>
  dayjs().year(year).month(month).startOf('month');

export const getBusinessCalendarMonth = (value: any) => ({
  year: value.year(),
  month: value.month(),
  daysInMonth: value.daysInMonth(),
});

export const formatMonthName = (month: number) =>
  createMonthDate(2000, month).format('MMMM');

export default dayjs;
